/* Geburtsdatum beim Anlegen eines Spielers prüfen.
 *
 * Reine Funktion, kein DOM. Gilt NUR beim Anlegen (NewPlayerDialog.vue) —
 * bestehende Spieler und das Bearbeiten bestehender Akten werden nicht geprüft
 * (dort darf ein Geburtsdatum weiter fehlen, Altbestand).
 *
 * Plausibler Bereich: 1. Januar 1950 bis heute (Auftrag F8, vorher 1990). Der Bereich
 * fängt Tippfehler beim Jahr ab (1900, 0200, 2062). Die Untergrenze ist eine
 * Konstante und lässt sich ändern.
 *
 * Das Datum kommt aus DateField.vue als "JJJJ-MM-TT" (leer, solange die
 * Eingabe unvollständig ist; domain/dateMask.js rechnet aus "TT.MM.JJJJ" um).
 */

import { isRealDate } from './dateMask.js';

export const MIN_BIRTH_YEAR = 1950;

const ISO = /^(\d{4})-(\d{2})-(\d{2})$/;

/** Heute als "JJJJ-MM-TT" in der Ortszeit des Geräts (nicht UTC — sonst wäre "heute" abends/früh um einen Tag falsch). */
export function todayIso(now = new Date()) {
  const p = (n) => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${p(now.getMonth() + 1)}-${p(now.getDate())}`;
}

/** Erlaubter Bereich für das Eingabefeld (min/max-Attribute). */
export function birthDateBounds(now = new Date()) {
  return { min: `${MIN_BIRTH_YEAR}-01-01`, max: todayIso(now) };
}

/**
 * @returns {null | 'required' | 'invalid' | 'future' | 'tooOld'}
 *   null = in Ordnung. Der Rückgabewert ist der Schlüssel unter newPlayer.dob.* in den Sprachdateien.
 */
export function validateBirthDate(dob, now = new Date()) {
  const s = typeof dob === 'string' ? dob.trim() : '';
  if (!s) return 'required';

  const m = ISO.exec(s);
  if (!m) return 'invalid';
  const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  // Kalendertag wirklich vorhanden? (31.02. und 29.02. in Nicht-Schaltjahren fallen durch)
  if (!isRealDate(y, mo, d)) return 'invalid';

  // ISO-Texte gleicher Länge lassen sich als Text vergleichen
  if (s > todayIso(now)) return 'future';
  if (y < MIN_BIRTH_YEAR) return 'tooOld';
  return null;
}
